import React  from "react";
import { AgreeLevel, OverallLevel, TaskName } from "../utils/comms";
import AnswerBubble from "./AnswerBubble";
import './AnswerBubbleSection.css'
import FeebackAnswer from "./FeedbackAnswer";
import TitleText from "./TitleText";
import SelectOption from "./SelectOption";
import TextArea from "./TextArea";


function AnswerBubbleSection({answers, requestFeedback, onUpdatedRequestFeedback}) {
    const leftRightAnswerId = {
        "Left": requestFeedback.answer_feedbacks[0].answer_id,
        "Right": requestFeedback.answer_feedbacks[1].answer_id
    };

    return (
        <div className="answer-bubble-section">
            <TitleText
                text={"Responses"}
            />
            <div className="answer-side">
                <AnswerBubble
                    text={answers[0].answer_txt}
                />
                <TitleText
                    text={"Response Feedback"}
                />
                <FeebackAnswer
                    initAnswerFeedback={requestFeedback.answer_feedbacks[0]}
                    handleFeedbackUpdated={(updatedLeftFeedback) => {
                        const updatedAnswerFeedbacks = [updatedLeftFeedback, requestFeedback.answer_feedbacks[1]];
                        onUpdatedRequestFeedback({answer_feedbacks: updatedAnswerFeedbacks});
                    }}
                />
            </div>
            <div className="answer-side">
                <AnswerBubble
                    text={answers[1].answer_txt}
                />
                <TitleText
                    text={"Response Feedback"}
                />
                <FeebackAnswer
                    initAnswerFeedback={requestFeedback.answer_feedbacks[1]}
                    handleFeedbackUpdated={(updatedRightFeedback) => {
                        const updatedAnswerFeedbacks = [requestFeedback.answer_feedbacks[0], updatedRightFeedback];
                        onUpdatedRequestFeedback({answer_feedbacks: updatedAnswerFeedbacks});
                    }}
                />
            </div>
            <div className="overall-feedback">
                <TitleText
                    text={"Overall Feedback"}
                />
                <div className="overall-feedback-left">
                    <p>What type of question did you ask the system? *</p>
                    <TextArea
                        onTextChanged={(types_text) => {
                            onUpdatedRequestFeedback({types: types_text});
                        }}
                    />
                    <SelectOption
                        id={"SelectOptionConfidence"}
                        promptText="I am familiar with the specific code related to the question I asked. *"
                        options={Object.values(AgreeLevel)}
                        onOptionSelect={(option_text) => {
                            onUpdatedRequestFeedback({expertise: option_text})
                        }}
                    />
                    <SelectOption
                        id={"SelectOptionTaskName"}
                        promptText="What was the task you were trying to solve when asking this question? *"
                        options={Object.values(TaskName)}
                        onOptionSelect={(option_text) => {
                            onUpdatedRequestFeedback({task_name: option_text})
                        }}
                    />
                    <SelectOption
                        id={"SelectOptionLeftRight"}
                        promptText="Which response do you prefer? *"
                        options={["Left", "Right"]}
                        onOptionSelect={(option_text) => {
                            onUpdatedRequestFeedback({preferred_answer_id: leftRightAnswerId[option_text]})
                        }}
                    />
                    <SelectOption
                        promptText="How satisfied are you with the overall quality of the preferred answer? *"
                        options={Object.values(OverallLevel)}
                        onOptionSelect={(option) => {
                            onUpdatedRequestFeedback({overall: option});
                        }}
                    />
                    <p>What is the reason for choosing this response over the other? *</p>
                    <TextArea
                        placeholder={""}
                        onTextChanged={(text) => {
                            onUpdatedRequestFeedback({user_preference: text})
                        }}
                    />
                </div>
            </div>
        </div>
    )
};

export default AnswerBubbleSection;

